import React from 'react';
import { Link } from '@mui/material';
import { theme } from '../../../../../../common/styles/theme';
import { Text } from '../../../../../../common/components/Text/Text';

const TERMS_URL = 'https://langmagic.com/terms';
const PRIVACY_URL = 'https://langmagic.com/privacy';

// Goes under every sign-in button
export const LoginConsent: React.FC = () => (
	<Text sx={{ fontSize: 13, color: theme.palette.grey[600], textAlign: 'center' }}>
		By signing in, you agree to our{' '}
		<Link href={TERMS_URL} target={'_blank'} rel={'noopener'}>Terms of Service</Link>
		{' '}and{' '}
		<Link href={PRIVACY_URL} target={'_blank'} rel={'noopener'}>Privacy Policy</Link>.
	</Text>
);
